import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { limpiarServicioConfiguracion, obtenerServicioConfiguracion } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

const DetallesServicio = ({ servicio, reestablecerServicio }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.servicios);

    const [detallesModal, setDetallesModal] = useState(false);

    const [servicioData, setServicioData] = useState({
        id: null,
        nombre: null,
        categoria: null,
        subcategoria: null,
        subsubcategoria: null,
        precio_venta: 0,
        descripcion: null
    });

    /* Detalles servicio */
    const handleCerrar = () => {
        setServicioData({
            id: null,
            nombre: null,
            categoria: null,
            subcategoria: null,
            subsubcategoria: null,
            precio_venta: 0,
            descripcion: null
        });

        setDetallesModal(false);
        reestablecerServicio(null);

        dispatch(limpiarServicioConfiguracion());
    }

    useEffect(() => {
        if(servicio){
            setDetallesModal(true);

            dispatch(obtenerServicioConfiguracion(servicio?.id));

            setServicioData({
                ...servicioData,
                categoria: servicio?.categoria?.nombre,
                subcategoria: servicio?.subcategoria?.nombre,
                subsubcategoria: servicio?.subsubcategoria?.nombre
            });
        }
    }, [servicio]);

    useEffect(() => {
        if(detalles){
            setServicioData({
                ...servicioData,
                id: detalles?.id,
                nombre: detalles?.nombre,
                categoria: servicio?.categoria?.nombre,
                subcategoria: servicio?.subcategoria?.nombre,
                subsubcategoria: servicio?.subsubcategoria?.nombre,
                precio_venta: detalles?.precio_venta,
                descripcion: detalles?.descripcion
            });
        }
    }, [detalles]);

    return (
        <Modal show={detallesModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Información del servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <label className="fw-bold">Nombre</label>
                        <p>{servicioData?.nombre || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Categoría</label>
                        <p>{servicioData?.categoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Subcategoría</label>
                        <p>{servicioData?.subcategoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Subsubcategoría</label>
                        <p>{servicioData?.subsubcategoria || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-12">
                        <label className="fw-bold">Precio</label>
                        <p>{formatNumber(servicioData?.precio_venta, 2, '$ ', '')}</p>
                    </div>

                    <div className="col-md-12">
                        <label className="fw-bold">Descripción</label>
                        <p>{servicioData?.descripcion || 'Sin descripción'}</p>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default DetallesServicio;
